import React, { useEffect, useState } from 'react';
/* Componentes */
import VideoToken from '../../components/new_videotoken'
/* Funciones */
import { validarOtorganteCDC } from '../../services/data'

const Index = () => {

    /* Hooks */
    const [apikey, setApikey] = useState('')
    const [uuidCliente, setUuidCliente] = useState('')
    const [uuidTransaccion, setUuidTransaccion] = useState('')
    const [nextStep, setNextStep] = useState('')
    const [dataOtorgante, setDataOtorgante] = useState([])

    useEffect(() => {

        const apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante) {
            setApikey(apikeyOtorgante)
        }

        const uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser) {
            setUuidCliente(uuidUser)
        }

        const uuidTrx = localStorage.getItem("uuidTrx");
        if (uuidTrx) {
            setUuidTransaccion(uuidTrx)
        }

        const dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS) {
            let dataOtorganteJSON = JSON.parse(dataOtorganteLS)
            setDataOtorgante(dataOtorganteJSON)
        }

        if (validarOtorganteCDC())
            setNextStep('/finalizado')
        else
            setNextStep('/consulta_historial')

    }, []);

    return (
        <>
            <VideoToken
                apikey={apikey}
                uuidCliente={uuidCliente}
                uuidTransaccion={uuidTransaccion}
                dataOtorgante={dataOtorgante}
                service_call={'videotoken-embedding'}
                previousStep={`/${apikey}`}
                nextStep={nextStep}
                cancelStep={`/selfie`}
                type={'selfie'}
                intents={'3'}
            />
        </>
    );
}

export default Index;
